<template>
  <RowItemAligned
    class="row-item"
    :labels="technicalDataLabels"
    :values="technicalDataValues"
    :editable="true"
    @edit="$emit('edit')"
    :last="isLast"
  />
</template>

<script>
import RowItemAligned from './RowItemAligned';

export default {
  name: 'CommonTechnicalData',
  props: {
    technicalData: { type: Object, required: true },
    deviceName: { type: String, required: true },
  },
  components: { RowItemAligned },
  computed: {
    technicalDataLabels() {
      const data = this.technicalData;
      if (!data) return ['-'];

      const labels = [];

      if (data.manufacturer !== undefined || data.type !== undefined) {
        labels.push(
          this.$t(`consumption_devices.order_details.${this.deviceName}`)
        );
      }

      if (data.control_type !== undefined) {
        labels.push(this.$t('consumption_devices.order_details.control_type'));
      }
      if (this.deviceName === 'wallbox' && data.load_management !== undefined) {
        labels.push(
          this.$t('consumption_devices.order_details.load_management')
        );
      }
      if (data.control_box_connection !== undefined) {
        labels.push(
          this.$t('consumption_devices.order_details.control_box_connection')
        );
      }

      return labels;
    },
    technicalDataValues() {
      const data = this.technicalData;
      if (!data) return ['-'];

      const values = [];

      function trimBr(s) {
        return (s || '').replace(/(<br>\s*)+$/g, '');
      }

      // manufacturer / type  block
      if (data.manufacturer !== undefined || data.type !== undefined) {
        let deviceData = '';
        if (data.manufacturer !== undefined) {
          deviceData +=
            this.$t('consumption_devices.order_details.manufacturer') +
            ': ' +
            data.manufacturer +
            '<br>';
        }
        if (data.type !== undefined) {
          deviceData +=
            this.$t('consumption_devices.order_details.type') +
            ': ' +
            data.type +
            '<br>';
        }
        values.push(trimBr(deviceData));
      }

      // control type
      if (data.control_type !== undefined) {
        values.push(
          this.$t(`consumption_devices.order_details.${data.control_type}`)
        );
      }

      // load management
      if (this.deviceName === 'wallbox' && data.load_management !== undefined) {
        values.push(this.getLoadManagementText(data.load_management));
      }

      // control box connection
      if (data.control_box_connection !== undefined) {
        values.push(this.getControlBoxText(data.control_box_connection));
      }

      return values;
    },
    isLast() {
      return (
        this.deviceName !== 'wallbox' && this.deviceName !== 'battery_storage'
      );
    },
  },
  methods: {
    getControlBoxText(value) {
      switch (value) {
        case 'EEBUS':
          return value;
        case 'relay':
          return this.$t('consumption_devices.order_details.relay');
        default:
          return value;
      }
    },
    getLoadManagementText(value) {
      switch (value) {
        case 'not_available':
          return this.$t(
            'consumption_devices.order_details.load_management_not_available'
          );
        case 'available':
          return this.$t(
            'consumption_devices.order_details.load_management_available'
          );
        default:
          return value;
      }
    },
  },
};
</script>

<style scoped>
.row-item {
  margin-block: 1px;
}
</style>
